import { render, staticRenderFns } from "./DJsAdmin.vue?vue&type=template&id=aa86a736&scoped=true"
import script from "./DJsAdmin.vue?vue&type=script&lang=js"
export * from "./DJsAdmin.vue?vue&type=script&lang=js"
import style0 from "./DJsAdmin.vue?vue&type=style&index=0&id=aa86a736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa86a736",
  null
  
)

export default component.exports